// import GettingStarted from "../GettingStarted";
// import Layout from "../Layout";
// import RegisterNextSteps from "../RegisterNextSteps";
const Layout = () => import(/* webpackChunkName: "group-register" */ '../Layout.vue')
const RegisterNextSteps = () => import(/* webpackChunkName: "group-register" */ '../RegisterNextSteps.vue')
const GettingStarted = () => import(/* webpackChunkName: "group-register" */ '../GettingStarted.vue')
export default [
  // Register page
  {
    path: "/register",
    name: "register",
    component: Layout
  },
  {
    path: "/register/nextstep",
    name: "nextstep",
    component: RegisterNextSteps
  },
  {
    path: "/register/getting-started",
    name: "getting-started",
    component: GettingStarted
  }
];
